'use client'

import { useToastActions, useToastState } from '@trustoo/components/ui/toaster/ToastContext'
import ToastList from '@trustoo/components/ui/toaster/ToastList'

/**
 * The `id` of the app toaster's container, for UI that has to tell a press on a toast apart from one
 * on the page, such as a panel that closes when the page is pressed.
 */
export const TOASTER_ID = 'app-toaster'

/**
 * Renders the active toasts from `ToastProvider`. Mount once, high in the tree (e.g. a root client
 * boundary), so toasts are app-wide.
 *
 * This container is a plain `fixed` element in the document, so it sits *below* the browser top
 * layer: a toast raised while a `BaseModal` is open would be painted behind that modal's backdrop.
 * Such a message belongs to the modal — use `useBaseModalToast()`.
 */
const Toaster = () => {
    const toasts = useToastState()
    const { deleteToast } = useToastActions()

    return (
        <ToastList
            id={TOASTER_ID}
            toasts={toasts}
            onToastExited={deleteToast}
            className="pointer-events-none fixed bottom-0 left-2 right-2 z-[9999] mx-auto max-w-[450px]"
            // The bottom-most toast is flush with the viewport edge, so only the ones above it are
            // rounded all round.
            popupClassName="[&:nth-last-child(n+2)]:rounded-[5px]"
        />
    )
}

export default Toaster
